// tslint:disable:no-any

import React, { Component } from 'react';

export interface IDiveRemoveModalProps {
    modalConfirm: () => void;
    hideModal: () => void;
    // tslint:disable-next-line:no-any
    display: any;
}

interface IDiveRemoveModalState {
    display: any;
}

export default class DiveRemoveModal extends Component<
    IDiveRemoveModalProps,
    IDiveRemoveModalState
> {
    constructor(props: IDiveRemoveModalProps) {
        super(props);

        this.state = {
            display: props.display
        };
    }

    componentWillReceiveProps(nextProps: IDiveRemoveModalProps) {
        this.setState({
            display: nextProps.display
        });
    }

    onClickConfirm(e: Event) {
        this.props.modalConfirm();
        e.preventDefault();
    }

    onClickClose(e: Event) {
        this.props.hideModal();
        e.preventDefault();
    }

    render() {
        return (
            <div
                className={
                    'modalOverlay' + (this.state.display ? '' : ' hidden')
                }
            >
                <div className="modalSlide">
                    <div className="modal removeDive">
                        <button
                            className="close"
                            onClick={e => this.onClickClose(e as any)}
                        />
                        <div className="modal-header">
                            <h3>Remove dive</h3>
                        </div>
                        <div className="modal-content cf">
                            <p>Are you sure you want to remove this dive ?</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn--xsmallpill btn--backroundRed"
                                onClick={e => this.onClickConfirm(e as any)}
                            >
                                Remove
                            </button>
                            <button
                                className="btn btn--xsmallpill btn--borderRed btn--colorRed"
                                onClick={e => this.onClickClose(e as any)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveRemoveModal.tsx